
import React from 'react'
import styles from './style.module.css'


const List = ({item}) => {
  return (
    <div className={styles.listItem} >
        <div className={styles.leftPart}>
            <div className={styles.box} >
                {item.ListNo}
            </div>
        </div>
        <div className={styles.rightPart}>
            <h5>{item.Title}</h5>
            <p>{item.Desc}</p>
        </div>
    </div>
  )
}

export default List